import React from 'react';
import { Button, ButtonMode } from '@components/atoms/Button';
import { useData } from '@hooks/useData';
import styles from './SelectAccountType.module.css';
import { useNavigate } from 'react-router-dom';
import { RoundProfilePicture } from '@components/atoms/RoundProfilePicture';
import { Space } from '@components/atoms/Space';
import { useTranslation } from 'react-i18next';
import { saveToLocalStorage } from '@utils/storage';
import { Role } from '@types';

export interface SelectAccountTypeProps {
    onNext: () => void;
}

export const SelectAccountType: React.FC<SelectAccountTypeProps> = () => {
    const { roles, setSelectedRole } = useData();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const translations = {
        who: t('role-select.who'),
        define: t('role-select.define'),
        driver: t('role-select.driver'),
        rider: t('role-select.rider'),
    };

    const roleRoutes: Record<string, string> = {
        Rider: '/register',
        Driver: '/register-driver-account',
    };

    const handleClick = (id?: number, name?: string) => {
        if (!id || !name) return;
        const route = roleRoutes[name];
        setSelectedRole({ id, name });
        saveToLocalStorage('selectedRole', { id: id, name: name });

        if (route && window.location.pathname !== route) {
            localStorage.setItem('previousPage', route);
            navigate(route);
        }
    };

    return (
        <div className={styles.pickerContainer}>
            <RoundProfilePicture icon="fa-thin fa-user-hair" labelText={translations.who} hintText={translations.define} />
            <Space spaceBreakpoints={{ xs: { space: 30 } }} />
            {roles?.data?.map((type: Role) => (
                <React.Fragment key={type.id ?? type.name}>
                    <Button
                        label={
                            type.name
                                ? (translations[type.name.toLowerCase() as keyof typeof translations] ?? type.name)
                                : t('role-select.unknown')
                        }
                        mode={ButtonMode.primary}
                        outline={false}
                        onClick={() => handleClick(type.id, type.name)}
                    />
                    <Space spaceBreakpoints={{ xs: { space: 15 } }} />
                </React.Fragment>
            ))}
        </div>
    );
};
